<template>
    <section
        v-infinite-scroll="showMore"
        infinite-scroll-disabled="scrollDisabled"
        class="row">
        <div class="col-sm-12">
            <slot/>
        </div>
        <div
            v-for="post in posts"
            :key="post.id"
            class="col-xs-12 col-sm-6 col-md-3">
            <a class="blog-item"
                :href="post.URL"
                :title="post.title">
                <div class="thumbnail">
                    <div class="fill">
                        <div class="img-container">
                        <img
                            v-if="post.featured_image"
                            :src="post.featured_image + '?w=316'"
                            :alt="post.title"
                            loading="lazy"
                            width="316"
                            height="316"
                            class="center-block">
                        </div>
                    </div>
                    <div class="caption">
                        <h4 v-html="post.title"/>
                        <div><strong>{{ post.dateForHumans }}</strong></div>
                        <v-clamp :max-lines="3">
                            {{post.excerpt}}
                        </v-clamp>
                        <div class="read-more">
                            Read more...
                        </div>
                    </div>
                </div>
            </a>
        </div>
        <div v-if="moreCount && !busy" class="col-xs-12 col-sm-12 text-center">
            <a href="#" @click.prevent.stop="showMore"><h4>Show More...</h4></a>
        </div>
        <div v-if="busy" class="col-xs-12 col-sm-12 text-center">
            <h4>Loading...</h4>
        </div>
    </section>
</template>

<style scoped>
    .read-more {
        margin-top: 5px;
        color: #403e38;
        font-size: 14px;
    }

    .thumbnail {
        border: 1px solid #ddd;
        padding: 5px;
    }

    .fill {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden
    }

    .fill .img-container {
        height: 240px;
        overflow: hidden;
    }

    .fill img {
        flex-shrink: 0;
        width: 100%;
        min-height: 240px;
    }

    .thumbnail .caption {
        font-size: larger;
        height: 200px;
        overflow: hidden;
    }

    .blog-item {
        text-decoration: none;
        color: black;
    }
</style>

<script>
    import axios from 'axios'
    import {jrNotifyEx} from '../bootstrap'
    import VClamp from "vue-clamp"
    import infiniteScroll from 'vue-infinite-scroll'

    export default {
        directives: {
            infiniteScroll,
        },

        components: {
            VClamp ,
        },

        props: {
            count: {
                type: Number,
                default: 4,
            },
            moreCount: {
                type: Number,
                default: 0,
            },
            readMore: {
                type: Boolean,
                default: true,
            },
        },

        data () {
            return {
                busy: false,
                cnt: 4,
                posts: []
            }
        },

        async created () {
            this.cnt = this.count || 4
            this.loadPosts()
        },

        methods: {
            async loadPosts () {
                this.busy = true
                try {
                    const response = await axios.get("/blog/posts/" + this.cnt)
                    this.posts = response.data.data
                } catch (e) {
                    jrNotifyEx(e)
                }
                this.busy = false
            },

            async showMore () {
                this.cnt += this.moreCount
                this.loadPosts()
            }
        },

        computed: {
            scrollDisabled () {
                return this.busy || !this.moreCount
            }
        }
    }
</script>
